import { Text } from "@ui-kitten/components";
import BaseCard from "components/BaseCard";
import Button from "components/Button";
import Spacer from "components/Spacer";
import { TicketProvisioningJobStatusDetails } from "features/types";
import React, { useMemo } from "react";
import { View } from "react-native";
import { useFetchMyInProgressTicketProvisioningJobsQuery } from "queries/ticketProvisioning.queries";

const StatusText = ({ status }: { status: TicketProvisioningJobStatusDetails["status"] }) => {
  const statusColor = {
    SUBMITTED: "info",
    PROCESSING: "primary",
    COMPLETE: "success",
    FAILED: "danger",
  } as const;

  return <Text status={statusColor[status]}>{status}</Text>;
};

export default function TicketProvisioningStatusBanner() {
  const { data: inProgressJobs, refetch, isFetching } =
    useFetchMyInProgressTicketProvisioningJobsQuery();

  const job = useMemo(() => inProgressJobs?.[0], [inProgressJobs]);

  if (!job) return null;

  return (
    <BaseCard style={{ marginBottom: 14 }}>
      <View style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
        <Text category="h6">Processing your tickets</Text>
        <StatusText status={job.status} />
      </View>
      <Spacer margin={8} />
      <Text appearance="hint">
        Your purchase is complete. We’re processing your tickets now and they’ll appear on your Dashboard once ready.
        This usually takes a few minutes.
      </Text>
      <Spacer margin={12} />
      <Button appearance="outline" size="small" onPress={() => refetch()} loading={isFetching}>
        Refresh status
      </Button>
    </BaseCard>
  );
}

